// extracted by mini-css-extract-plugin
module.exports = {"cta":"PricingCta_cta__CULMr"};